// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sg-filter {
  position: relative;
  display: flex;
  align-items: center;
  margin: 1.25rem 0 0.5rem;
  color: var(--text-tertiary);
}

.sg-filter svg {
  position: absolute;
  left: 0.85rem;
  pointer-events: none;
}

.sg-filter input {
  width: 100%;
  padding-left: 2.5rem;
}

.sg-category {
  margin-top: 1.75rem;
}

.sg-category-title {
  margin: 0 0 0.5rem;
  padding-bottom: 0.3rem;
  border-bottom: 2px solid var(--text-primary);
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
}

.sg-category-description {
  margin: 0.4rem 0 0.75rem;
  font-size: 0.92rem;
  color: var(--text-secondary);
}

.sg-options .guide-faq:first-of-type {
  border-top: 0;
}

.sg-option summary {
  font-weight: 400;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}

.sg-option[open] summary {
  font-weight: 700;
}

/* Datenfeld-Optionen: Name links, Beschreibung rechts */
.sg-cat-icon {
  display: inline-flex;
  margin: -0.25rem 0 0.5rem;
}

.sg-rows {
  display: grid;
  margin: 0;
  border-top: 1px solid var(--border-primary);
}

.sg-rows > div {
  display: grid;
  grid-template-columns: minmax(0, 15rem) minmax(0, 1fr);
  gap: 0.25rem 1.25rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid var(--border-primary);
  scroll-margin-top: calc(var(--header-height) + 1rem);
}

.sg-rows dt {
  font-family: var(--font-mono);
  font-size: 0.84rem;
  font-weight: 600;
  color: var(--text-primary);
  overflow-wrap: break-word;
}

.sg-rows dd {
  margin: 0;
}

.sg-rows dd p {
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-secondary);
}

.sg-avail {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.35rem;
}

.sg-avail-chip {
  padding: 0 0.4rem;
  border: 1px solid var(--signal);
  font-family: var(--font-mono);
  font-size: 0.64rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  line-height: 1.6;
  text-transform: uppercase;
  color: var(--signal);
}

@media (max-width: 600px) {
  .sg-rows > div {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/guides/SettingsGuidePage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,oBAAoB;EACpB,kBAAkB;EAClB,8CAA8C;EAC9C,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".sg-filter {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 1.25rem 0 0.5rem;\n  color: var(--text-tertiary);\n}\n\n.sg-filter svg {\n  position: absolute;\n  left: 0.85rem;\n  pointer-events: none;\n}\n\n.sg-filter input {\n  width: 100%;\n  padding-left: 2.5rem;\n}\n\n.sg-category {\n  margin-top: 1.75rem;\n}\n\n.sg-category-title {\n  margin: 0 0 0.5rem;\n  padding-bottom: 0.3rem;\n  border-bottom: 2px solid var(--text-primary);\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.sg-category-description {\n  margin: 0.4rem 0 0.75rem;\n  font-size: 0.92rem;\n  color: var(--text-secondary);\n}\n\n.sg-options .guide-faq:first-of-type {\n  border-top: 0;\n}\n\n.sg-option summary {\n  font-weight: 400;\n  padding-top: 0.7rem;\n  padding-bottom: 0.7rem;\n}\n\n.sg-option[open] summary {\n  font-weight: 700;\n}\n\n/* Datenfeld-Optionen: Name links, Beschreibung rechts */\n.sg-cat-icon {\n  display: inline-flex;\n  margin: -0.25rem 0 0.5rem;\n}\n\n.sg-rows {\n  display: grid;\n  margin: 0;\n  border-top: 1px solid var(--border-primary);\n}\n\n.sg-rows > div {\n  display: grid;\n  grid-template-columns: minmax(0, 15rem) minmax(0, 1fr);\n  gap: 0.25rem 1.25rem;\n  padding: 0.65rem 0;\n  border-bottom: 1px solid var(--border-primary);\n  scroll-margin-top: calc(var(--header-height) + 1rem);\n}\n\n.sg-rows dt {\n  font-family: var(--font-mono);\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow-wrap: break-word;\n}\n\n.sg-rows dd {\n  margin: 0;\n}\n\n.sg-rows dd p {\n  margin: 0;\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n}\n\n.sg-avail {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-top: 0.35rem;\n}\n\n.sg-avail-chip {\n  padding: 0 0.4rem;\n  border: 1px solid var(--signal);\n  font-family: var(--font-mono);\n  font-size: 0.64rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  line-height: 1.6;\n  text-transform: uppercase;\n  color: var(--signal);\n}\n\n@media (max-width: 600px) {\n  .sg-rows > div {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
